
import './style.css';

const EmbeddedVideo = ({ src: src, isThumbnail: isThumbnail }) => {

	return (
		<div className="video-container">
			<iframe
				src={src}
				title="YouTube Video"
				allowFullScreen
			></iframe>
		</div>
	);
};

export default EmbeddedVideo;